import PropTypes from 'prop-types';
import React from 'react';

import { ATTACHMENTS } from 'newJs/config';
import { Button } from 'components/Button';
import { ButtonPane } from './styles';
import { FaIcon } from 'components/Icons';
import { isScreenSize } from 'newJs/utils';
import { useAttachsState } from 'providers/attachs-state';
import GroupActions from 'containers/Attachments/misc/GroupedActions';

const { VIEW_MODE } = ATTACHMENTS;

export default function Toolbar({ i18n }) {
    const { currentBreakpoint, setStateValue } = useAttachsState();
    const isXsScreen = isScreenSize.xs(currentBreakpoint.name);

    return (
        <ButtonPane>
            <GroupActions showDownloadAll showGridBtn={false} />
            <div className="btn-group">
                <Button
                    data-test="eml-attachment-show-grid"
                    className="btn_grid-view"
                    onClick={() => setStateValue('currentViewMode', VIEW_MODE.GRID, true)}
                >
                    <FaIcon name="FaTh" />
                    {!isXsScreen && (
                        <span className='inner-text'>
                            {i18n.viewAsGrid}
                        </span>
                    )}
                </Button>
            </div>
        </ButtonPane>
    );
}

Toolbar.propTypes = { i18n: PropTypes.object.isRequired };
